import { GET_LATEST_NEWS,GET_EXT_NEWS } from "shared/constants/ActionTypes";

const initialState = {
    kkpData:{
        latestNews:[],
        extNews:[]
    }
};

const pageKKPReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_LATEST_NEWS:
            return {
                kkpData : {
                    ...state.kkpData,
                    latestNews:action.payload
                }
            }
        case GET_EXT_NEWS:
            return {
                kkpData : {
                    ...state.kkpData,
                    extNews:action.payload
                }
            }
        default:
            return {
                ...state
            }
    }
};

export default pageKKPReducer;